import { useEffect, useRef, useCallback } from "react";

function useSafeTimeout() {
    const timeoutsRef = useRef(new Set());

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            timeoutsRef.current.forEach(clearTimeout);
            timeoutsRef.current.clear();
        };
    }, []);

    // Set timeout
    const setSafeTimeout = useCallback((fn, delay) => {
        const id = setTimeout(() => {
            timeoutsRef.current.delete(id); // auto cleanup
            fn();
        }, delay);

        timeoutsRef.current.add(id);
        return id;
    }, []);

    // Cancel timeout by id
    const cancelTimeout = useCallback((id) => {
        if (timeoutsRef.current.has(id)) {
            clearTimeout(id);
            timeoutsRef.current.delete(id);
        }
    }, []);

    return { setSafeTimeout, cancelTimeout };
}

export default useSafeTimeout;
